import { bridge } from '../../bridge';

/**
 * - 앱의 경우 추천탭으로 이동
 * - 웹의경우 홈으로 이동
 */
export const moveToToday = () => {
  bridge.openPath('/home/today', {
    webPath: '/today',
  });
};
